import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navItems = [
    { id: 1, path: '/', label: 'Home' },
    { id: 2, path: '/about', label: 'About Us' },
    { id: 3, path: '/what-we-do', label: 'What We Do' },
    { id: 4, path: '/projects', label: 'Projects' },
    { id: 5, path: '/opportunities', label: 'Opportunities' },
    { id: 6, path: '/updates', label: 'Updates' },
    { id: 7, path: '/contact', label: 'Contact' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top bar with contact info and hours - Sticky */}
      <div 
        className="bg-primary text-white py-2 sticky-top"
        style={{ 
          fontSize: '0.875rem',
          zIndex: 1040,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
              <span className="me-4">
                <i className="bi bi-clock me-2"></i>
                <span className="fw-light">Mon-Fri: 9:00 AM - 5:00 PM</span>
              </span>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <a href="tel:+254712345678" className="text-white text-decoration-none me-4 hover-opacity">
                <i className="bi bi-telephone-fill me-2"></i>
                <span>+254 711 538258</span>
              </a>
              <a href="mailto:info@sikom.org" className="text-white text-decoration-none hover-opacity">
                <i className="bi bi-envelope-fill me-2"></i>
                <span>info@sikompeacenet.org</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav 
        className={`navbar navbar-expand-lg navbar-light fixed-top transition-all ${
          scrolled ? 'bg-white shadow-lg py-2' : 'bg-white py-3'
        }`}
        style={{ 
          top: '44px',
          transition: 'all 0.3s ease-in-out',
          zIndex: 1030
        }}
      >
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center animate-fade-in" to="/">
            <div className="logo-container position-relative">
              <img 
                src="/images/logos/spnlogo.png" 
                alt="SIKOM Logo" 
                className="me-2 logo-image"
                style={{
                  height: '40px',          // adjust this value to make it smaller/larger
                  width: 'auto',           // maintain aspect ratio
                  transition: 'transform 0.3s ease',
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.1) rotate(5deg)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1) rotate(0deg)'}
              />
            </div>
          </Link>


          <button 
            className="navbar-toggler border-0 shadow-none" 
            type="button" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation"
            style={{ transition: 'transform 0.2s ease' }}
          >
            <span className={`navbar-toggler-icon ${isMenuOpen ? 'rotate-icon' : ''}`}></span>
          </button>

          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="navbar-nav ms-auto align-items-center">
              {navItems.map((item, index) => (
                <li 
                  className="nav-item mx-2 nav-item-animated" 
                  key={item.id}
                  style={{
                    animationDelay: `${index * 0.05}s`
                  }}
                >
                  <NavLink
                    className={({ isActive }) => 
                      `nav-link px-3 position-relative nav-link-hover ${
                        isActive ? 'text-primary fw-semibold active-nav' : 'text-dark'
                      }`
                    }
                    to={item.path}
                    end={item.path === '/'}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              
              <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
                <Link 
                  to="/donate" 
                  className="btn btn-primary px-4 py-2 donate-btn"
                  onClick={() => setIsMenuOpen(false)}
                  style={{
                    transition: 'all 0.3s ease',
                    fontWeight: '600',
                    letterSpacing: '0.5px'
                  }}
                >
                  <i className="bi bi-heart-fill me-2"></i>
                  Donate
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <style>{`
          .transition-all {
            transition: all 0.3s ease-in-out;
          }

          .hover-opacity {
            transition: opacity 0.3s ease;
          }

          .hover-opacity:hover {
            opacity: 0.8;
          }

          .nav-link-hover {
            transition: all 0.3s ease;
          }

          .nav-link-hover::after {
            content: '';
            position: absolute;
            width: 0;
            height: 2px;
            bottom: -2px;
            left: 50%;
            background-color: #0d6efd;
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }

          .nav-link-hover:hover::after,
          .nav-link-hover.active-nav::after {
            width: 80%;
          }

          .nav-link-hover:hover {
            color: #0d6efd !important;
            transform: translateY(-2px);
          }

          .donate-btn {
            position: relative;
            overflow: hidden;
            z-index: 1;
          }

          .donate-btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.2);
            transition: left 0.5s ease;
            z-index: -1;
          }

          .donate-btn:hover::before {
            left: 100%;
          }

          .donate-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(13, 110, 253, 0.4);
          }

          .donate-btn:active {
            transform: translateY(0);
          }

          .logo-image {
            filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
          }

          .navbar-toggler:focus {
            box-shadow: none;
          }

          .rotate-icon {
            animation: rotate 0.3s ease;
          }

          @keyframes rotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(90deg); }
          }

          .nav-item-animated {
            animation: slideIn 0.4s ease forwards;
            opacity: 0;
          }

          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .animate-fade-in {
            animation: fadeIn 0.6s ease;
          }

          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          @media (max-width: 991px) {
            .navbar-collapse {
              margin-top: 1rem;
              padding: 1rem;
              background: #f8f9fa;
              border-radius: 8px;
              animation: slideDown 0.3s ease;
            }

            @keyframes slideDown {
              from {
                opacity: 0;
                transform: translateY(-20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            .nav-link-hover::after {
              display: none;
            }
          }

          .shadow-lg {
            box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
          }

          /* Icon animations */
          .bi {
            transition: transform 0.3s ease;
          }

          a:hover .bi {
            transform: scale(1.1);
          }

          .btn:hover .bi-heart-fill {
            animation: heartbeat 0.6s ease infinite;
          }

          @keyframes heartbeat {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
        `}</style>
      </nav>
    </>
  );
};

export default Navbar;